<template>
  <b-alert
    show
    class="tw-p-3 tw-bg-[#1a6a72] tw-text-white tw-text-center tw-border-none tw-mb-0 tw-flex tw-justify-center tw-items-center"
  >
    <div class="tw-w-[23px] tw-h-[23px] tw-mr-2">
      <svg
        width="23"
        height="23"
        viewBox="0 0 2000 2000"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          id="Path"
          fill="#ffffff"
          stroke="none"
          d="M 1000 2000 C 1552.28479 2000 2000 1552.284668 2000 1000 C 2000 447.71521 1552.28479 0 1000 0 C 447.715271 0 0 447.71521 0 1000 C 0 1552.284668 447.715271 2000 1000 2000 Z M 982.75647 836.018311 C 1194.382568 798.495605 1281.20874 985.730469 1245.373901 1125.191406 C 1182.565186 1373.79126 830.973022 1590.913086 830.973022 1590.913086 C 830.973022 1590.913086 479.378235 1373.41748 416.573029 1125.191406 C 381.540009 985.730469 468.826965 798.495605 680.036499 836.060913 C 765.634766 851.382568 831.395691 953.31311 831.395691 953.31311 C 831.395691 953.31311 897.156494 851.382568 982.75647 836.018311 Z M 1414.626099 412.036621 C 1552.182617 389.244385 1608.704224 503.713013 1585.991211 588.889526 C 1545.304321 740.500854 1316.539063 873.373901 1316.539063 873.373901 C 1316.539063 873.373901 1087.765259 740.500854 1047.078247 588.889526 C 1024.373901 503.713013 1080.886963 389.244385 1218.443481 412.036621 C 1273.695679 421.406982 1316.539063 483.790527 1316.539063 483.790527 C 1316.539063 483.790527 1358.956543 421.406982 1414.626099 412.036621 Z"
        />
      </svg>
    </div>

    <div>
      <span class="tw-font-atten-medium tw-tracking-wider tw-text-md lg:tw-text-lg tw-align-middle">
        <span class="tw-uppercase tw-font-bold">Galentine's Deal —</span> <span class="tw-font-atten"> Estriol + Tretinoin Skincare for <span class="tw-font-atten tw-font-bold">Only $99.</span> Limited Time Offer!</span>
      </span>
      <div class="tw-inline-block">
        <b-button
          size="sm"
          variant="info"
          class="tw-hidden lg:tw-inline-block tw-px-5 tw-py-1 tw-font-atten-bold tw-border-transparent tw-ml-2 tw-text-xs lg:tw-text-sm !tw-rounded-md"
          @click="$emit('open-upsell')"
        >
          Get Deal
        </b-button>
        <b-button
          size="sm"
          variant="link"
          class="tw-inline-block lg:tw-hidden tw-px-1 tw-py-0 tw-font-atten-bold tw-border-transparent tw-text-sm lg:tw-text-sm !tw-rounded-md tw-text-white tw-underline"
          @click="$emit('open-upsell')"
        >
          Get Deal
        </b-button>
      </div>
    </div>
  </b-alert>
</template>

<script>
export default {
  name: 'BFCMBanner',
}
</script>